import { formatLink } from "@/components/terra/utils/formatLink"
import formatIcons from "@/components/terra/utils/formatIcons"
import { formatNavPromo } from "./FormatNavPromo"

import {
  formatNavCategoryVariant as formatNavCategoryVariantLib,
  formatCategoryLinks as formatCategoryLinksLib,
} from "@/lib/formatters/formatNavCategoryVariant"
import {
  createProductTrialPageLink,
  createProductDetailPageLink,
} from "@/components/terra/utils/createProductPageLinks"

export const formatNavCategory = (navCategory: any, locale: string) => {
  const currentLocale = locale || navCategory?.currentLocale
  return {
    id: navCategory?.contentfulId || navCategory?.id,
    text: navCategory?.title || navCategory?.text,
    type:
      navCategory?.isMegaNav === true && navCategory?.type === "category"
        ? "megaNav"
        : navCategory?.type,
    contentfulId: navCategory?.contentfulId,
    displayChevrons: navCategory?.displayChevrons,
    disableLinkDescriptions: navCategory?.disableLinkDescriptions,
    featuredSection: navCategory?.featuredCategory && {
      title: navCategory?.featuredCategory?.title,
      links: [
        ...(navCategory?.featuredCategory?.navigationItems?.map(
          (item: any, _i: number) => {
            const renderedLink =
              item?.pageLink?.__typename === "ContentfulExternalLink"
                ? item?.pageLink?.externalUrl
                : item?.pageLink?.slug
                  ? formatLink(
                      `/${item?.pageLink?.slug}`,
                      currentLocale,
                      item?.pageLink?.__typename,
                      navCategory?.homepageSlug,
                    )
                  : null
            return {
              text: item?.title,
              external:
                item?.pageLink?.__typename === "ContentfulExternalLink"
                  ? true
                  : false,
              type: "link",
              contentfulId: item?.id || item?.contentfulId,
              icon: formatIcons(item?.icon?.icon),
              description: item?.description,
              url: renderedLink,
            }
          },
        ) ?? []),
      ],
    },
    featuredLinksTitle:
      navCategory?.featuredLinks?.length ||
      navCategory?.featuredLinksToProductTrialPages
        ? navCategory?.featuredLinksSectionTitle
        : null,
    featuredLinks:
      navCategory?.featuredLinks
        ?.filter((midItem: any) => {
          return (
            midItem?.__typename === "ContentfulExternalLink" ||
            midItem?.__typename === "ContentfulPageBase" ||
            midItem?.__typename === "ContentfulProductTrialPage" ||
            midItem?.__typename === "ContentfulProductPage" ||
            midItem?.__typename === "ContentfulProductDetailPage"
          )
        })
        ?.map((midItem: any) => {
          if (midItem?.__typename === "ContentfulExternalLink") {
            return {
              url: midItem?.url,
              text: midItem?.text,
              type: "link",
              external: true,
              contentfulId: midItem?.id,
            }
          } else if (midItem?.__typename === "ContentfulPageBase") {
            // if (midItem?.regions && midItem?.regions.length > 0) {
            //   const regionMatch = findRegionMatch(midItem, navCategory?.regions);
            //   if (regionMatch) {
            //     return null;
            //   }
            // }
            return {
              url: formatLink(
                `/${midItem?.slug}`,
                currentLocale,
                null,
                navCategory?.homepageSlug,
              ),
              text: midItem?.pageName,
              type: "link",
              contentfulId: midItem?.id,
              isPublicPage:
                navCategory?.rawNavigationData?.midItem?.isPublicPage,
            }
          } else if (midItem?.__typename === "ContentfulProductTrialPage") {
            return createProductTrialPageLink(currentLocale, midItem)
          } else if (midItem?.__typename === "ContentfulProductPage") {
            // if (midItem?.regions && midItem?.regions.length > 0) {
            //   // const regionMatch = findRegionMatch(midItem, navCategory?.regions);

            //   if (regionMatch) {
            //     return null;
            //   }
            // }
            return {
              url: formatLink(
                `/products/${midItem?.slug}`,
                currentLocale,
                null,
                navCategory?.homepageSlug,
              ),
              text: midItem?.pageName,
              type: "link",
              contentfulId: midItem?.id,
              isPublicPage:
                navCategory?.rawNavigationData?.midItem?.isPublicPage,
            }
          } else if (midItem?.__typename === "ContentfulProductDetailPage") {
            return createProductDetailPageLink(currentLocale, midItem)
          } else {
            return {}
          }
        }) || [],
    navCategoryPromo: navCategory?.navCategoryPromo
      ? formatNavPromo(
          navCategory?.navCategoryPromo,
          navCategory?.homepageSlug,
          currentLocale,
        )
      : null,

    categoryLink: navCategory?.categoryLink
      ? {
          text:
            navCategory?.categoryLink?.title ||
            navCategory?.categoryLink?.pageLink?.text ||
            navCategory?.categoryLink?.pageLink?.pageName,
          url: navCategory?.categoryLink?.pageLink?.slug
            ? formatLink(
                `/${navCategory?.categoryLink?.pageLink?.slug}`,
                currentLocale,
                null,
                navCategory?.homepageSlug,
              )
            : navCategory?.categoryLink?.pageLink?.externalUrl,
        }
      : null,
    links: navCategory?.navigationItems
      ?.filter((midItem: any) => {
        return (
          midItem?.__typename === "ContentfulExternalLink" ||
          midItem?.__typename === "ContentfulPageBase" ||
          midItem?.__typename === "ContentfulNavigationSubcategory" ||
          midItem?.__typename === "ContentfulProductTrialPage" ||
          midItem?.__typename === "ContentfulProductPage" ||
          midItem?.__typename === "ContentfulNavigationItemLink" ||
          midItem?.__typename === "ContentfulProductDetailPage"
        )
      })
      ?.map((midItem: any) => {
        if (midItem?.__typename === "ContentfulExternalLink") {
          return {
            url: midItem?.url,
            text: midItem?.text,
            contentfulId: midItem?.id,
            type: "link",
            external: true,
          }
        } else if (midItem?.__typename === "ContentfulNavigationItemLink") {
          const renderedMidItem = midItem?.pageLink
            ? midItem?.pageLink
            : midItem
          // if (
          //   renderedMidItem?.regions &&
          //   renderedMidItem?.regions.length > 0
          // ) {
          //   // const regionMatch = findRegionMatch(renderedMidItem);
          //   const regionMatch = false;
          //   if (regionMatch) {
          //     return null;
          //   }
          // }
          return {
            url: formatLink(
              renderedMidItem?.externalUrl
                ? renderedMidItem?.externalUrl
                : `/${renderedMidItem?.slug}`,
              currentLocale,
              null,
              navCategory?.homepageSlug,
            ),
            // use navItemLink title over linked page Name
            text: midItem?.title || renderedMidItem?.pageName,
            type: "link",
            contentfulId: renderedMidItem?.id,
            isPublicPage: renderedMidItem?.isPublicPage,
          }
        } else if (midItem.__typename === "ContentfulPageBase") {
          // if (midItem?.regions && midItem?.regions.length > 0) {
          //   // const regionMatch = findRegionMatch(midItem);
          //   const regionMatch = false;
          //   if (regionMatch) {
          //     return null;
          //   }
          // }
          return {
            url: formatLink(
              `/${midItem?.slug}`,
              currentLocale,
              null,
              navCategory?.homepageSlug,
            ),
            text: midItem?.pageName,
            type: "link",
            contentfulId: midItem?.id,
            isPublicPage: midItem?.isPublicPage,
          }
        } else if (midItem.__typename === "ContentfulProductPage") {
          // if (midItem?.regions && midItem?.regions.length > 0) {
          //   // const regionMatch = findRegionMatch(midItem);
          //   const regionMatch = false;
          //   if (regionMatch) {
          //     return null;
          //   }
          // }
          return {
            url: formatLink(
              `/${midItem?.slug}`,
              currentLocale,
              "ContentfulProductPage",
              navCategory?.homepageSlug,
            ),
            text: midItem?.pageName,
            type: "link",
            contentfulId: midItem?.id,
            isPublicPage: midItem?.isPublicPage,
          }
        } else {
          if (midItem?.__typename === "ContentfulProductTrialPage") {
            return createProductTrialPageLink(currentLocale, midItem)
          }
          if (midItem?.__typename === "ContentfulProductDetailPage") {
            return createProductDetailPageLink(currentLocale, midItem)
          }
          return {
            text: midItem?.title,
            title: midItem?.title || null,
            description: midItem?.description || null,
            contentfulId: midItem?.id,
            navSubcategoryPromo: midItem?.navCategoryPromo
              ? formatNavPromo(
                  midItem?.navCategoryPromo,
                  navCategory?.homepageSlug,
                  currentLocale,
                )
              : null,
            subCategoryLink: {
              text: midItem?.subCategoryLink?.title,
              external:
                midItem?.subCategoryLink?.pageLink?.__typename ===
                "ContentfulExternalLink"
                  ? true
                  : false,
              type: "link",
              contentfulId:
                midItem?.subCategoryLink?.id ||
                midItem?.subCategoryLink?.contentfulId,
              description: midItem?.subCategoryLink?.description,
              url:
                midItem?.subCategoryLink?.pageLink?.__typename ===
                "ContentfulExternalLink"
                  ? midItem?.subCategoryLink?.pageLink?.externalUrl
                  : midItem?.subCategoryLink?.pageLink?.slug
                    ? formatLink(
                        `/${midItem?.subCategoryLink?.pageLink?.slug}`,
                        currentLocale,
                        midItem?.subCategoryLink?.pageLink?.__typename,
                        navCategory?.homepageSlug,
                      )
                    : midItem?.subCategoryLink?.pageLink?.__typename ===
                          "ContentfulProductDetailPage" &&
                        midItem?.subCategoryLink?.pageLink?.slug
                      ? `/${currentLocale}/products/${midItem?.subCategoryLink?.pageLink?.slug}/buy`
                      : null,
            },
            links: midItem?.navigationItems
              ?.filter(
                (item: any) =>
                  item?.__typename === "ContentfulExternalLink" ||
                  item?.__typename === "ContentfulNavigationTertiaryCategory" ||
                  item?.__typename === "ContentfulImage" ||
                  item?.__typename === "ContentfulPageBase" ||
                  item?.__typename === "ContentfulProductPage" ||
                  item?.__typename === "ContentfulProductTrialPage" ||
                  item?.__typename === "ContentfulNavigationItemLink" ||
                  item?.__typename === "ContentfulProductDetailPage",
              )
              ?.map((lastItem: any) => {
                if (lastItem?.__typename === "ContentfulNavigationItemLink") {
                  const renderedLink =
                    lastItem?.pageLink?.__typename === "ContentfulExternalLink"
                      ? lastItem?.pageLink?.externalUrl
                      : lastItem?.pageLink?.slug
                        ? formatLink(
                            `/${lastItem?.pageLink?.slug}`,
                            currentLocale,
                            lastItem?.pageLink?.__typename,
                            navCategory?.homepageSlug,
                          )
                        : lastItem?.pageLink?.__typename ===
                              "ContentfulProductDetailPage" &&
                            lastItem?.pageLink?.slug
                          ? `/${currentLocale}/products/${lastItem?.pageLink?.slug}/buy`
                          : null
                  return {
                    text: lastItem?.title,
                    external:
                      lastItem?.pageLink?.__typename ===
                      "ContentfulExternalLink"
                        ? true
                        : false,
                    type: "link",
                    contentfulId: lastItem?.id || lastItem?.contentfulId,
                    icon: formatIcons(lastItem?.icon?.icon),
                    description: lastItem?.description,
                    url: renderedLink,
                  }
                } else if (lastItem?.__typename === "ContentfulImage") {
                  return {
                    text: lastItem?.title,
                    url: formatLink(
                      lastItem?.link?.url,
                      currentLocale,
                      null,
                      navCategory?.homepageSlug,
                    ),
                    type: "link",
                    contentfulId: lastItem?.id,
                    description: lastItem?.link?.description || "",
                    imageUrl: lastItem?.image?.file?.url,
                  }
                } else if (lastItem?.__typename === "ContentfulExternalLink") {
                  return {
                    text: lastItem?.text,
                    contentfulId: lastItem?.id,
                    url: lastItem?.externalUrl || lastItem?.url,
                    type: "link",
                    external: true,
                  }
                } else if (lastItem?.__typename === "ContentfulPageBase") {
                  // if (
                  //   lastItem?.regions &&
                  //   lastItem?.regions.length > 0
                  // ) {
                  //   // const regionMatch = findRegionMatch(lastItem);
                  //   const regionMatch = false;
                  //   if (regionMatch) {
                  //     return null;
                  //   }
                  // }
                  return {
                    url: formatLink(
                      `/${lastItem?.slug}`,
                      currentLocale,
                      null,
                      navCategory?.homepageSlug,
                    ),
                    text: lastItem?.pageName,
                    type: "link",
                    contentfulId: lastItem?.id,
                    isPublicPage: lastItem?.isPublicPage,
                  }
                } else if (lastItem?.__typename === "ContentfulProductPage") {
                  // if (
                  //   lastItem?.regions &&
                  //   lastItem?.regions.length > 0
                  // ) {
                  //   // const regionMatch = findRegionMatch(lastItem, navCategory?.regions);
                  //   const regionMatch = false;
                  //   if (regionMatch) {
                  //     return null;
                  //   }
                  // }
                  return {
                    url: formatLink(
                      `/${lastItem?.slug}`,
                      currentLocale,
                      lastItem?.__typename,
                      null,
                      navCategory?.homepageSlug,
                    ),
                    text: lastItem?.pageName,
                    type: "link",
                    isPublicPage: lastItem?.isPublicPage,
                    contentfulId: lastItem?.id,
                  }
                } else {
                  if (lastItem?.__typename === "ContentfulProductTrialPage") {
                    return createProductTrialPageLink(currentLocale, lastItem)
                  }
                  if (lastItem?.__typename === "ContentfulProductDetailPage") {
                    return createProductDetailPageLink(currentLocale, lastItem)
                  }
                  return {
                    icon: formatIcons(lastItem?.icon?.icon),
                    text: lastItem?.title,
                    contentfulId: lastItem?.id,
                    links: lastItem?.navigationItems
                      ?.filter(
                        (item: any) =>
                          item?.__typename === "ContentfulExternalLink" ||
                          item?.__typename === "ContentfulPageBase" ||
                          item?.__typename === "ContentfulProductTrialPage" ||
                          item?.__typename === "ContentfulProductPage",
                      )
                      ?.map((item: any) =>
                        item?.__typename === "ContentfulExternalLink"
                          ? {
                              text: item?.text,
                              url: item?.url,
                              type: "link",
                              contentfulId: item?.id,
                              description: item?.description,
                              imageUrl: item?.image?.image?.file?.url,
                            }
                          : item?.__typename === "ContentfulPageBase"
                            ? {
                                url: formatLink(
                                  `/${item?.slug}`,
                                  currentLocale,
                                  null,
                                  navCategory?.homepageSlug,
                                ),
                                text: item?.pageName,
                                type: "link",
                                contentfulId: item?.id,
                                isPublicPage: item.isPublicPage,
                              }
                            : item?.__typename === "ContentfulProductPage"
                              ? {
                                  url: formatLink(
                                    `/${item?.slug}`,
                                    currentLocale,
                                    "ContentfulProductPage",
                                    navCategory?.homepageSlug,
                                  ),
                                  text: item?.pageName,
                                  type: "link",
                                  contentfulId: item?.id,
                                  isPublicPage: item.isPublicPage,
                                }
                              : item?.__typename ===
                                  "ContentfulProductTrialPage"
                                ? createProductTrialPageLink(
                                    currentLocale,
                                    item,
                                  )
                                : item?.__typename ===
                                    "ContentfulProductDetailPage"
                                  ? createProductDetailPageLink(
                                      currentLocale,
                                      item,
                                    )
                                  : {},
                      ),
                  }
                }
              }),
          }
        }
      }),
    ntExperiencesCollection: navCategory?.ntExperiencesCollection || [],
  }
}

/** Re-export from lib for client components that import from here. */
export const formatNavCategoryVariant = formatNavCategoryVariantLib

/** Re-export from lib for client components that import from here. */
export const formatCategoryLinks = formatCategoryLinksLib

// const findRegionMatch = (item: any, currentRegion: any) => {
//   return item?.regions?.find((reg: any) => {
//     return (
//       reg?.machineName?.toLowerCase() === currentRegion?.machineName?.toLowerCase()
//     );
//   });
// };
